import styled from 'styled-components';
import { Text } from '@perch-labs/shrike';

export const ErrorText = styled(Text)`
  text-align: end;

  ${props => props.theme.media.small`
    text-align: start;
  `}
`;
